import { environment as LrnEnv } from './BaseEnvironments/Lrn';
var Environment = () => {
  var env: any = LrnEnv;
  env.apiUrl = 'https://lrn.wcs-servizi.it/api';
  return env;
}

export var environment = Environment();